import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const gitea = defineConnector({
  identifier: "gitea",
  name: "Gitea",
  tagLine: "Self-hosted Git service",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.accessToken,
        scheme: "token",
      },
    ]),
  steps: [
    {
      title: "Get your Gitea access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Gitea, go to **Settings > Applications** and generate a new access token with the permissions you need.",
        },
      ],
    },
    {
      title: "Enter your Gitea details",
      items: [
        {
          kind: "url",
          label: "Gitea instance URL",
          required: true,
          placeholder: "https://gitea.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Gitea instance.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/v1/user`,
  },
});
